module.exports = __webpack_public_path__ + "img/lowell.1ed5ad23.jpg";